export const blockIconsNotificationEventBusy = (
	<span className='material-symbols-outlined'>event_busy</span>
);
